import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SimpleBarChart } from '../../../../core/components/SimpleBarChart';
import { useTranslation } from 'react-i18next';
import { Card } from '../../../../core/components/Card';
import { millifyNumber } from '../../../../utils/millify-number';

export const BarChart = ({ data, isHorizontal = false, sx, title, loading = true }) => {
  const { t } = useTranslation();
  const [simpleBarChartData, setSimpleBarChartData] = useState(null);

  useEffect(() => {
    if (data && t) {
      const categories = Object.keys(data).sort((a, b) => data?.[b] - data?.[a]);
      setSimpleBarChartData({
        labels: categories,
        datasets: [
          {
            label: '',
            data: isHorizontal
              ? categories.map((category) =>
                  data?.[category]?.count ? data?.[category]?.count : data?.[category] || 0
                )
              : categories.map((category) =>
                  data?.[category]?.count
                    ? millifyNumber(data?.[category]?.count)
                    : millifyNumber(data?.[category]) || 0
                ),
            backgroundColor: '#258CF4'
          }
        ]
      });
    }
  }, [data, t]);

  return (
    <Card
      sx={{
        ...sx,
        maxWidth: isHorizontal ? '383px' : 'calc(100% - 415px)'
      }}
    >
      <SimpleBarChart
        data={simpleBarChartData}
        title={t(`telemetry.${title}`)}
        isHorizontal={isHorizontal}
        loading={loading}
      />
    </Card>
  );
};

BarChart.propTypes = {
  data: PropTypes.object,
  isHorizontal: PropTypes.bool,
  sx: PropTypes.object,
  title: PropTypes.string,
  loading: PropTypes.bool
};

export default BarChart;
